import { styled } from '@mui/material/styles';

const GradientText = styled('span')(({ theme, color = 'primary' }) => ({
  background: `linear-gradient(to right, #0408E7, #C334EB)`,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
}));

export default GradientText;